import { AddRateCardRequest } from "../../../pages/clients/ratecard/dtos/AddRateCardRequest";
import { UpdateRateCardRequest } from "../../../pages/clients/ratecard/dtos/UpdateRateCardRequest";
import {
  RatecardListUIResponse,
  RatecardUIResponse,
  StoreRateCardAssociationListUIResponse,
  StringArrayUIResponse,
} from "../../models/ApiResponse";
import { axiosRequests } from "../axiosRequest";

export const RatecardAgent = {
  getRateCardList: (clientId: number) =>
    axiosRequests.get<RatecardListUIResponse>(
      `/fdc-commandops/ratecards/client/${clientId}`
    ),
  getRateCardById: (id: number) =>
    axiosRequests.get<RatecardUIResponse>(`/fdc-commandops/ratecards/${id}`),
  fetchStoreRateCardAssociationList: (clientId: number) =>
    axiosRequests.get<StoreRateCardAssociationListUIResponse>(
      `/fdc-commandops/ratecards/fetch-store-ratecard-association/${clientId}`
    ),
  fetchRegionNameListForFuelSurcharge: (fuelType: string) =>
    axiosRequests.getWithQueryParam<StringArrayUIResponse>(
      `/fdc-commandops/ratecards/fetch-region-name-list-for-fuel-surcharge`,
      {
        params: {
          fuelType: fuelType,
        },
      }
    ),
  addRateCard: (clientId: number, rateCard: AddRateCardRequest) =>
    axiosRequests.post<RatecardListUIResponse>(
      `/fdc-commandops/ratecards/client/${clientId}`,
      rateCard
    ),
  updateRatecard: (ratecardId: number, rateCard: UpdateRateCardRequest) =>
    axiosRequests.put<RatecardUIResponse>(
      `/fdc-commandops/ratecards/${ratecardId}`,
      rateCard
    ),

  exportRatecardData: (args: {
    clientId: number;
    ratecardIds: string;
    startDate: string;
    endDate: string;
  }) =>
    axiosRequests.getWithQueryParam<any>(
      "/fdc-commandops/ratecards/export-ratecard-in-xlsx",
      {
        params: {
          clientId: args.clientId,
          ratecardIds: args.ratecardIds,
          startDate: args.startDate,
          endDate: args.endDate,
        },
        responseType: "blob",
      }
    ),
};
